import { hashCode } from "../index.js";
import { AccumulatingObservable } from "./AccumulatingObservable.js";
export var LogLevel;
(function (LogLevel) {
    LogLevel["Log"] = "Log";
    LogLevel["Info"] = "Info";
    LogLevel["Warn"] = "Warn";
    LogLevel["Error"] = "Error";
})(LogLevel || (LogLevel = {}));
export class LogMessage {
    constructor(level, message, optionalParams = []) {
        this.level = level;
        this.message = message;
        this.optionalParams = optionalParams;
    }
    get key() {
        return `${this.level}_${this.message}_${this.optionalParams.join("_")}`;
    }
    get levelMessageHash() {
        return hashCode(`${this.level}_${this.message}`);
    }
    equals(other) {
        return this.key === other.key;
    }
}
function notInArray(target, m) {
    return target.every((a) => !a.equals(m));
}
export class LogObservable extends AccumulatingObservable {
    constructor() {
        super();
        this.addPrebaked = (m, toConsoleLog = false) => {
            if (notInArray(this.accumulated, m)) {
                this.notifyAll(m);
            }
            if (toConsoleLog) {
                const message = m.message;
                const optionalParams = m.optionalParams;
                switch (m.level) {
                    case LogLevel.Info:
                        console.info(message, ...optionalParams);
                        break;
                    case LogLevel.Warn:
                        console.warn(message, ...optionalParams);
                        break;
                    case LogLevel.Error:
                        console.error(message, ...optionalParams);
                        break;
                    default:
                        console.log(message, ...optionalParams);
                }
            }
        };
        this.someLog = (level, message, ...optionalParams) => {
            this.addPrebaked(new LogMessage(level, message, optionalParams), true);
        };
        LogObservable._allObservables.push(this);
    }
    static get accumulate() {
        return this._accumulate;
    }
    static set accumulate(v) {
        this._accumulate = v;
        if (!v) {
            this.clear();
        }
    }
    static get allMessages() {
        return this._allObservables.reduce((a, o) => {
            o.accumulated.forEach((m) => {
                if (notInArray(a, m)) {
                    a.push(m);
                }
            });
            return a;
        }, []);
    }
    static clear() {
        for (const o of this._allObservables) {
            o.clear();
        }
    }
    info(message, ...optionalParams) {
        this.someLog(LogLevel.Info, message, ...optionalParams);
    }
    warn(message, ...optionalParams) {
        this.someLog(LogLevel.Warn, message, ...optionalParams);
    }
    warnFromCaught(e) {
        this.warn(`${e}`);
    }
    error(message, ...optionalParams) {
        this.someLog(LogLevel.Error, message, ...optionalParams);
    }
    errorFromCaught(e) {
        this.error(`${e}`);
    }
    errorAsObject(message, ...optionalParams) {
        this.someLog(LogLevel.Error, message, ...optionalParams);
        return new Error(message + "\n " + optionalParams.join("a"));
    }
}
LogObservable._allObservables = [];
LogObservable._accumulate = true;
